import React from 'react';
export default [
  {
    lines: [
      '1. Select the number of layers (2 or 4).',
      '2. Enter the board size in inches.',
      '3. Select silkscreen side (None, Top, Bottom or Both Sides).',
      '4. Enter the part number and revision for your circuit board.',
      '5. Attach a zip files with all the board layers.',
    ],
  },
  {
    title: 'Need USA Quickturn PCBs?',
    lines: [
      '2 layers as fast as 24 hours.',
      '4 layers as fast as 48 hours.',
      `<a href="${Spree.routes.product_usa_quickturn_pcbs_url}" class="btn btn-sm btn-primary-clear mt-2">Instant Quote</a> `
    ],
  },
  {
    title: 'Need Offshore PCBs',
    lines: [
      'We partner with multiple PCB factories in China and Taiwan allowing us to offer a broad range of manufacturing capabilities.',
      'Select the factory that is best suited for your PCB project based on price, lead time and capabilities.',
      `<a href="${Spree.routes.product_offshore_pcbs_url}" class="btn btn-sm btn-primary-clear mt-2">Instant Quote</a>`
    ]
  }
];
